"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var office_ui_fabric_react_1 = require("office-ui-fabric-react");
var Slider_1 = require("./Slider");
var Events = /** @class */ (function (_super) {
    __extends(Events, _super);
    function Events(props) {
        var _this = _super.call(this, props) || this;
        _this.eventDeleted = function () {
            _this.getData("Events/Get")
                .then(function (data) {
                _this.setState({ eventData: data });
            });
        };
        _this.saveEvent = function () {
            _this.saveNewEvent(_this.state.newEventName)
                .then(function () {
                return _this.getData("Events/Get")
                    .then(function (data) {
                    _this.setState({ eventData: data, newEventName: "", hideDialog: true });
                });
            });
        };
        _this.newChanged = function (event, newValue) {
            _this.setState({ newEventName: newValue });
        };
        _this.saveNewEvent = function (name) {
            return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    fetch('api/Events/Post?FileName=' + name, {
                        headers: new Headers({
                            'Content-Type': 'application/json',
                            'Authorization': 'Basic QW5kaTpBbmRpJ3NCdXJnZXI='
                        }),
                        method: 'get'
                    })
                        .then(function (response) {
                        if (response.status === 200) {
                            resolve();
                        }
                        else {
                            reject();
                        }
                    });
                    return [2 /*return*/];
                });
            }); });
        };
        _this.state = { eventData: [], hideDialog: true, newEventName: "" };
        _this.getData("Events/Get")
            .then(function (data) {
            _this.setState({ eventData: data });
        });
        return _this;
    }
    Events.prototype.render = function () {
        var _this = this;
        var theme = office_ui_fabric_react_1.Customizations.getSettings(["theme"]).theme;
        return (React.createElement(React.Fragment, null,
            React.createElement(reactstrap_1.Container, null,
                React.createElement(reactstrap_1.Row, null,
                    React.createElement(reactstrap_1.Col, { md: 12, style: { paddingBottom: "15px", paddingTop: "15px" } },
                        React.createElement("div", { style: {
                                fontSize: "20px", fontWeight: 600, color: theme.palette.themePrimary,
                                display: this.state.eventData.length === 0 && !this.props.isAdmin ? "none" : "block"
                            } }, "Events")),
                    React.createElement(reactstrap_1.Col, { md: 12 }, this.state.eventData.map(function (x) { return (React.createElement(Slider_1.default, { isAdmin: _this.props.isAdmin, folderName: x.replace(".json", ""), fileName: x.replace(".json", ""), deletedEvent: _this.eventDeleted })); })),
                    this.props.isAdmin &&
                        React.createElement(reactstrap_1.Col, { style: { paddingLeft: "50%", paddingRight: "50%" } },
                            React.createElement(office_ui_fabric_react_1.IconButton, { iconProps: { iconName: 'Add' }, title: "Neues Event", ariaLabel: "Neues Event", onClick: function () { return _this.setState({ hideDialog: false }); } })))),
            React.createElement(office_ui_fabric_react_1.Dialog, { hidden: this.state.hideDialog, onDismiss: function () { return _this.setState({ hideDialog: true }); }, dialogContentProps: {
                    type: office_ui_fabric_react_1.DialogType.normal,
                    title: 'Neues Event'
                }, modalProps: {
                    isBlocking: true,
                    styles: { main: { maxWidth: 6000 } }
                } },
                React.createElement(office_ui_fabric_react_1.TextField, { label: "Eventname", required: true, onChange: this.newChanged }),
                React.createElement(office_ui_fabric_react_1.DialogFooter, null,
                    React.createElement(office_ui_fabric_react_1.DefaultButton, { onClick: this.saveEvent, text: "Speichern" })))));
    };
    Events.prototype.getData = function (url) {
        var _this = this;
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                fetch('api/' + url, {
                    headers: new Headers({
                        'Content-Type': 'application/json',
                        'Authorization': 'Basic QW5kaTpBbmRpJ3NCdXJnZXI='
                    })
                })
                    .then(function (response) { return response.json(); })
                    .then(function (data) { return resolve(data); })
                    .catch(function (error) { return reject(error); });
                return [2 /*return*/];
            });
        }); });
    };
    return Events;
}(React.Component));
exports.default = Events;
//# sourceMappingURL=Events.js.map